import { useMemo } from 'react'
import type { ActivityResponse } from '@stream-io/feeds-client'

import { NotificationItem, NotificationSource } from '@/entities/Notification/Notification'
import { transformActivityToNotification } from '@/entities/Notification/NotificationTransformers'

import { useInAppEnabledCategories } from './useInAppEnabledCategories'
import { useNotificationReadState } from './useNotificationReadState'

interface UseFeedNotificationsResult {
    notifications: NotificationItem[]
    unreadCount: number
    markAllRead: () => void
}

export const useFeedNotifications = (activities: ActivityResponse[], userId: string): UseFeedNotificationsResult => {
    const { lastReadAt, markAllRead } = useNotificationReadState(NotificationSource.feed, userId)
    const inAppEnabledCategories = useInAppEnabledCategories(userId)

    const notifications = useMemo(() => activities
        .filter(activity => activity.user.id !== userId)
        .map(activity => transformActivityToNotification(activity, lastReadAt))
        .filter(notification => inAppEnabledCategories[notification.category])
        .sort((activityA, activityB) => activityB.createdAt.getTime() - activityA.createdAt.getTime()), [activities, userId, lastReadAt, inAppEnabledCategories])

    const unreadCount = useMemo(
        () => notifications.filter(notification => ! notification.read).length,
        [notifications],
    )

    return { notifications, unreadCount, markAllRead }
}
